import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contact } from '../contact';
import { ContactList } from '../contactList';

@Component({
  selector: 'app-contact-check',
  templateUrl: './contact-check.component.html',
  styleUrls: ['./contact-check.component.css']
})
export class ContactCheckComponent implements OnInit {
  contactItem!: Contact;
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.contactItem = {"name": params.name, "email": params.email, "subject": params.subject, "message": params.message};
    });
  }

}
